import { css } from '@emotion/react'

export const s = css`
  height: auto;
  > path {
    fill: currentColor;
  }
`
